import React, { useState } from 'react';
import BrButton from '@components/BrButton';
import BrSelect from '@components/BrSelect';
import ColorStyles from '@components/ColorStyles';

const BulkActionApplier = (props) => {
  const { actionGroup, selectRowConfig, selectedRows, useBulkActions } = props;

  const [selectedActionItem, setSelectedActionItem] = useState();

  const handleSelectAction = (actionItem) => {
    setSelectedActionItem(actionItem);
  };

  const handleApply = () => {
    const callback = selectedActionItem.onClick || selectRowConfig.onClickAction;
    if (callback) {
      callback(selectedRows, selectedActionItem);
    }
  };

  return actionGroup.options ? (
    <React.Fragment key={actionGroup.key}>
      {useBulkActions ? (
        selectedRows?.length > 0 ? (
          <>
            <BrSelect
              placeholder={actionGroup.title}
              options={actionGroup.options}
              isReturnWholeItem
              onSelect={handleSelectAction}
              selected={selectedActionItem}
              useV2DownCaret={useBulkActions}
            />
            {selectedActionItem ? (
              <BrButton title="Apply" onClick={handleApply} colorStyle={ColorStyles.BGBLUE} />
            ) : null}
          </>
        ) : null
      ) : (
        <>
          <BrSelect
            placeholder={actionGroup.title}
            options={actionGroup.options}
            isReturnWholeItem
            onSelect={handleSelectAction}
            selected={selectedActionItem}
            useV2DownCaret={useBulkActions}
          />
          {selectedActionItem ? (
            <BrButton
              title={`Apply ${`(${selectedRows.length})`}`}
              onClick={handleApply}
              colorStyle={ColorStyles.BGBLUE}
            />
          ) : null}
        </>
      )}
    </React.Fragment>
  ) : (
    <BrButton key={actionGroup.key} title={actionGroup.title} onClick={() => handleSelectAction(actionGroup)} />
  );
};

export default BulkActionApplier;
